"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var js_cookie_1 = __importDefault(require("js-cookie"));
function ProfileBgroup() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    return (react_1.default.createElement(material_1.Box, { sx: { position: "absolute", right: "20" } },
        react_1.default.createElement(material_1.ButtonGroup, { color: "primary", variant: "contained", sx: {
                display: "flex",
                flexDirection: "column",
                padding: "20px",
                justifyContent: "space-between",
            } },
            react_1.default.createElement(material_1.Button, { component: react_router_dom_1.Link, to: "/wishlist" }, "WishList"),
            react_1.default.createElement(material_1.Button, { component: react_router_dom_1.Link, to: "/user-orders" }, "Orders"),
            react_1.default.createElement(material_1.Button, { onClick: function () {
                    js_cookie_1.default.remove("token");
                    js_cookie_1.default.remove("role");
                    navigate("/login");
                } }, "LOGOUT"))));
}
exports.default = ProfileBgroup;
